import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import DonationSuccess from "@/pages/DonationSuccess";
import DonationCancel from "@/pages/DonationCancel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/donation/success" element={<DonationSuccess />} />
          <Route path="/donation/cancel" element={<DonationCancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FDFBF7",
            border: "1px solid #EADAB9",
            color: "#1F1A17",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
